import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Global } from "../../global";
import { TranslateService } from "@ngx-translate/core";
import { ClientesTestesSoproService } from "./clientes-testes-sopro.service";

@Component({
  selector: 'app-pdf-meus-testes-sopro',
  templateUrl: './pdf-meus-testes-sopro.component.html'
})
export class PdfMeusTestesSoproComponent implements OnInit {

  idTeste: string = '';
  urlPrincipal: string = '';
  listPdfs: any[] = [];
  pdfUrls: { [key: string]: string } = {};
  abaAtiva: string = 'principal';
  carregando: boolean = true;

  constructor(
    public global: Global,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private clientesTestesSoproService: ClientesTestesSoproService
  ) {}

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idTeste = params['id_teste'];
      let lang = this.translate.currentLang || 'pt';

      // URL do PDF principal
      this.urlPrincipal = this.clientesTestesSoproService.getPdfUrl(this.idTeste, lang);

      // Carrega dados do teste para obter lista de anexos
      this.carregando = true;
      this.clientesTestesSoproService.getById(this.idTeste).subscribe(
        res => {
          let data = res ? res.Payload : null;
          while (Array.isArray(data) && data.length === 1 && typeof data[0] === 'object' && !data[0].id_pdf) {
            data = data[0];
          }
          if (Array.isArray(data) && data.length > 0 && data[0] && data[0].pdfs) {
            data = data[0];
          }

          if (data && data.pdfs && Array.isArray(data.pdfs) && data.pdfs.length > 0) {
            this.listPdfs = data.pdfs.filter(item => item && item.id_pdf);
            this.carregando = false;
          } else {
            this.carregarPdfs();
          }
        },
        () => {
          this.carregarPdfs();
        }
      );
    });
  }

  carregarPdfs() {
    this.clientesTestesSoproService.getPdfs(this.idTeste).subscribe(
      res => {
        this.carregando = false;
        let payload = res ? res.Payload : null;
        while (Array.isArray(payload) && payload.length === 1 && Array.isArray(payload[0])) {
          payload = payload[0];
        }
        if (Array.isArray(payload)) {
          this.listPdfs = payload.filter(item => item && item.id_pdf);
        } else if (payload && payload.id_pdf) {
          this.listPdfs = [payload];
        }
      },
      () => {
        this.carregando = false;
      }
    );
  }

  selecionarAba(abaId: string) {
    this.abaAtiva = abaId;
    if (abaId !== 'principal') {
      if (!this.pdfUrls[abaId]) {
        this.pdfUrls[abaId] = this.clientesTestesSoproService.getPdfAnexoUrl(this.idTeste, abaId);
      }
    }
  }

  formatNomeAba(nome: string): string {
    if (!nome) return '';
    if (nome.length > 30) {
      return nome.substring(0, 30) + '...';
    }
    return nome;
  }

}



// WEBPACK FOOTER //
// ./src/app/area-cliente/meus-testes-sopro/pdf-meus-testes-sopro.component.ts